<div class="layout-error">
  <div class="layout-error__content">
    <div class="layout-error__content-title">Error</div>
    <div class="layout-error__content-description">
      Ha ocurrido un error, la página no fue encontrada
    </div>
    <div class="layout-error__content-actions">
      <button type="button" class="btn-primary" (click)="goToHome()">
        Volver al inicio
      </button>
    </div>
    <div class="layout-error__content-footer">
      Será redirigido a la página principal en {{ timer }}
      {{ timer === 1 ? 'segundo' : 'segundos' }}
    </div>
  </div>
</div>
